import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatepickerService } from '../../class/datepicker/datepicker.service';
import { Broadcaster } from '../../service/Broadcaster';

@Component({
  selector: 'app-top-panel',
  templateUrl: './top-panel.component.html',
  styleUrls: ['./top-panel.component.css'],
  providers: [DatepickerService]
})
export class TopPanelComponent implements OnInit {

  datepicker: any = {};
  set: any;
  settings: any = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    viewType: 'daysOfMonth',
    dealerGroupId: 0,
    quarter: 0,
  };
  params: any;
  selected: any;


  constructor(
    private datepickerActions: DatepickerService, 
    private route: ActivatedRoute,
    private elRef: ElementRef,
    private broadcaster: Broadcaster
  ) { }

  ngOnInit() {
    this.datepicker = this.datepickerActions.getDatepicker();
    this.broadcaster.on<any>('sendBudgetData').subscribe(data =>{
      this.datepicker.val = this.datepickerActions.updateValue(this.settings);
    });
    this.set = this.route.queryParams.subscribe(params => {
      this.params = params;
      this.settings.dealerGroupId = +params['id'] || 0;
      let settings: any = JSON.parse(window.localStorage.getItem('settings'));
      if (settings === null) {
        settings = { month: new Date().getMonth() + 1, year: new Date().getFullYear(), viewType: 'daysOfMonth', quarter: 1 };
        window.localStorage.setItem('settings', JSON.stringify(settings));
      }
      this.settings.month = +(Number(params['month']) + 1) || settings.month;
      this.settings.year = settings.year;
      this.settings.viewType = settings.viewType;
      this.settings.quarter = settings.quarter;
      if (this.settings.viewType === 'monthsOfYear') {
          this.datepicker.month = this.datepickerActions.DefaultMonth();
      }
      else {
          this.datepicker.month[parseInt(this.settings.month) - 1].class = 'datepicker-list-select';
          this.selected = this.datepicker.month[parseInt(this.settings.month) - 1];
      }

      this.datepicker.range = this.datepickerActions.updateRange(settings.viewType);
      this.datepicker.val = this.datepickerActions.updateValue(this.settings);
    });
  }
  ToggleCalendar(){
    $('.datepicker-fon').fadeToggle(200);
  }
  trackByIndex(index, item) {
    return index;
}
  UpdateYear(item: number): string {
    if (item === this.settings.year) {
        return 'datepicker-years-select';
    }
    return '';
  }

  SelectYears(obj: any, year: number): void {
    this.elRef.nativeElement.querySelector('.datepicker-years-item').classList.remove('datepicker-years-select');
    obj.currentTarget.classList.add('datepicker-years-select');
    this.settings.year = year;
  }

  selectMonth(month: number) {
    if (this.settings.viewType === 'monthsOfQuarter') {
        this.settings.quarter = this.datepickerActions.updateQuarter(month);
    }
    window.localStorage.setItem('settings', JSON.stringify({
        month: String(month),
        year: this.settings.year, viewType: this.settings.viewType,
        quarter: this.settings.quarter
    }));
    if (this.params['month'] !== undefined && this.params['month'] !== String(month)) {
        window.location.href = `/rtb?id=${this.settings.dealerGroupId}`;
        return;
    }
    this.settings.month = month;
    this.updateData();
  }

  SelectData(obj: any, val: string, i: number): void {
    this.datepicker.range = this.datepickerActions.DefaultRange();
    this.datepicker.range[i].class = 'datepicker-data-select';
    let selectQuarter: boolean = false;
    if (this.settings.viewType === 'daysOfMonth' && val === 'monthsOfQuarter') {
        selectQuarter = true;
        this.settings.quarter = this.datepickerActions.updateQuarter(Number(this.settings.month));
    }
    this.settings.viewType = val;
    if (val === 'monthsOfYear' || selectQuarter === true) {
        window.localStorage.setItem('settings', JSON.stringify({
            month: String(this.settings.month),
            year: this.settings.year, viewType: this.settings.viewType,
            quarter: this.settings.quarter
        }));
        $('.datepicker-fon').fadeOut(100);
        this.updateData();
        if (val === 'monthsOfYear') {
            this.datepicker.month = this.datepickerActions.DefaultMonth();
        }

    }

  }

  updateData(){
    this.broadcaster.broadcast("updateBudgetFromDate", {
      data: this.settings
    });
    if (this.settings.viewType === 'monthsOfYear') {
      this.datepicker.month = this.datepickerActions.DefaultMonth();
    }
    else {
      this.datepicker.month[parseInt(this.settings.month) - 1].class = 'datepicker-list-select';
      this.selected.class = "datepicker-list-line";
      this.selected = this.datepicker.month[parseInt(this.settings.month) - 1];
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/budget/top-panel/top-panel.component.ts